module.exports = __webpack_public_path__ + "static/media/Rediet Gashaw-Resume.cb36915e.pdf";